<script lang="ts">
    import { type SearchResult } from '$src/domain/searches/SearchResult';
    import { SearchResultType } from '$src/domain/searches/SearchResultType';
    import TimeSince from '$src/presentation/core/time-since.svelte';
    import { getTranslation } from '$src/presentation/core/TranslatedTextUtils';
    import { t } from 'svelte-i18n';
    import { languageCode } from '$src/presentation/core/languageCode';
    import { ShoppingCart } from 'lucide-svelte';
    import { User } from 'lucide-svelte';
    import { Euro } from 'lucide-svelte';
    import { push } from 'svelte-spa-router';
    import type { AuthContext } from '$src/infrastructure/accounts/AuthContext';
    import { ContextTokens } from '$src/presentation/contexts/ContextTokens';
    import { getContext } from 'svelte';

    export let resultItem: SearchResult;
    let { activeGroupStore }  : AuthContext = getContext(ContextTokens.Auth);
    
    function viewResult() {

      var detailUrl = `/gs/${$activeGroupStore?.groupStoreId}/`;

      switch(resultItem.resultType) {
        case SearchResultType.Customer:
          detailUrl += `customers/${resultItem?.itemId}`;
          break;
        case SearchResultType.Project:
          detailUrl += `customers/${resultItem.customerId}/projects/${resultItem.itemId}`;
          break;
        case SearchResultType.Invoice:
          detailUrl += 'customers/' + resultItem.itemId;
          break;
      }

      push(detailUrl);
    }
</script>

<button class="flex items-center space-x-4 rounded-md border p-4 hover:bg-accent" on:click={viewResult}>
    {#if resultItem.resultType == SearchResultType.Project }
      <ShoppingCart />
    {:else if resultItem.resultType == SearchResultType.Customer }
      <User />
    {:else}
      <Euro />
    {/if}
    <div class="flex-1 space-y-1">
      <div class="flex w-full flex-col gap-1">
        <div class="flex items-center">
          <div class="flex items-center gap-2">
            <div class="font-semibold">{resultItem.title}</div>
          </div>
          <div class="ml-auto text-xs text-muted-foreground">
            <TimeSince dateString={resultItem.date} />
          </div>
        </div>
      </div>
      <div class="flex w-full flex-col gap-1">
        <div class="flex items-center">
          <div class="line-clamp-2 text-xs text-muted-foreground">
            {@html resultItem.description?.replace(/\n/g, '<br>')}
          </div>
          <div class="ml-auto text-xs text-muted-foreground">
            {getTranslation(resultItem.infoText, $languageCode)}
            {#if resultItem.resultType == SearchResultType.Customer }
              {$t('page.search.results.sales')}
            {/if}
          </div>
        </div>
      </div>
    </div>
</button>